import {fetch} from '@infra/api/fetch';

export interface MaintenanceConfigApiResponse {
  enabled: boolean;
  tradenames: string[] | null;
  countries: string[] | null;
  additionalCriteria: Record<string, Record<string, unknown> | string | boolean | number | null>;
}

export const maintenanceApi = {
  getMaintenanceConfig: async (): Promise<MaintenanceConfigApiResponse> => {
    const response = await fetch('/api/maintenance/config', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch maintenance config');
    }

    return response.json();
  },
};
